// extracted by mini-css-extract-plugin
export default {"advtBlock":"Advt_advtBlock__wHyZJ","title":"Advt_title__OAj9V","qrBlock":"Advt_qrBlock__1TlKr","qrItem":"Advt_qrItem__1RSl7","qr":"Advt_qr__2uscH"};